function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-282"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266,249.17V268c0,1.41,1,2,2.21,1.28l24.6-14.21a4.9,4.9,0,0,0,2.21-3.83V232.42c0-1.41-1-2-2.21-1.28l-24.6,14.21A4.86,4.86,0,0,0,266,249.17Z",
    style: {
      fill: "#92E3A9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-282",
    d: "M92.26,435.51C181.09,483,325.13,483,414,435.51s88.84-124.38,0-171.83-232.87-47.45-321.7,0S3.42,388.06,92.26,435.51Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-282"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.93,350.09l-2.56-1.48a8.31,8.31,0,0,1-3.76-6.52V117.68a8.31,8.31,0,0,1,3.76-6.52L187.87,51.4a8.33,8.33,0,0,1,7.53,0L198,52.88a8.31,8.31,0,0,1,3.76,6.52V283.81a8.31,8.31,0,0,1-3.76,6.52L94.47,350.09A8.35,8.35,0,0,1,86.93,350.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.75,122.07l-14-8.1a7.7,7.7,0,0,0-1.1,3.71V342.09a8.31,8.31,0,0,0,3.76,6.52l2.56,1.48a8.35,8.35,0,0,0,7.54,0l1.28-.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7,123.51V347.92c0,2.4,1.69,3.37,3.77,2.17L198,290.33a8.31,8.31,0,0,0,3.76-6.52V59.4c0-2.4-1.68-3.37-3.76-2.17L94.47,117A8.36,8.36,0,0,0,90.7,123.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,137.69l94.11-54.33c1.78-1,3.23-.19,3.23,1.87v179a7.16,7.16,0,0,1-3.23,5.6L99,324.18c-1.79,1-3.23.19-3.23-1.87v-179A7.11,7.11,0,0,1,99,137.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.22,92.93c1.39-.8,2.52-.15,2.52,1.46a5.57,5.57,0,0,1-2.52,4.37c-1.4.81-2.53.15-2.53-1.45A5.59,5.59,0,0,1,146.22,92.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.93,105.54c5.13-2.83,14.27-8.28,19.33-11.25.86-.51,1.55-.16,1.55.78a3.36,3.36,0,0,1-1.56,2.59l-19.36,11.18c-.86.5-1.56.14-1.56-.79A3.21,3.21,0,0,1,138.93,105.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,108.37c.78-.46,1.41-.09,1.41.81a3.13,3.13,0,0,1-1.41,2.46c-.78.45-1.42.08-1.42-.82A3.14,3.14,0,0,1,134,108.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.22,302.73c2.78-1.61,5-.31,5,2.91a11.15,11.15,0,0,1-5,8.74c-2.79,1.61-5.05.31-5.05-2.91A11.15,11.15,0,0,1,146.22,302.73Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bank-card--inject-282"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.5,338.79a4.75,4.75,0,0,1-2.07-3.75V215.66a4.88,4.88,0,0,1,2.21-3.83l153.15-88.42a4.15,4.15,0,0,1,6.36,3.67V246.46a4.88,4.88,0,0,1-2.21,3.83L255.79,338.72A4.77,4.77,0,0,1,251.5,338.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.13,126.71c-.16-1.14-1.08-1.56-2.19-.91L255.79,214.22a4.44,4.44,0,0,0-1.56,1.65l-4.15-2.39a4.44,4.44,0,0,1,1.56-1.65L404.8,123.4a4.13,4.13,0,0,1,6.33,3.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.27,338.94a.44.44,0,0,1-.16.06,1.12,1.12,0,0,1-.31.1l-.17,0a1.65,1.65,0,0,1-.32.06l-.26,0a4.42,4.42,0,0,1-1.15,0,3.72,3.72,0,0,1-1.39-.43,4.73,4.73,0,0,1-2.08-3.75V215.65a4.5,4.5,0,0,1,.65-2.17l4.15,2.39a4.53,4.53,0,0,0-.65,2.18V337.44a1.5,1.5,0,0,0,.73,1.47,1,1,0,0,0,.35.1,1.45,1.45,0,0,0,.41,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,249.17V268c0,1.41,1,2,2.21,1.28l24.6-14.21a4.9,4.9,0,0,0,2.21-3.83V232.42c0-1.41-1-2-2.21-1.28l-24.6,14.21A4.86,4.86,0,0,0,266,249.17Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-282)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.98,
    y: 244.87,
    width: 43.09,
    height: 1,
    transform: "translate(-85.13 173.27) rotate(-30.02)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.81,
    y: 248.96,
    width: 1,
    height: 9.6,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.25,
    y: 241.82,
    width: 1,
    height: 9.58,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.98,
    y: 254.49,
    width: 43.09,
    height: 1,
    transform: "translate(-89.94 174.56) rotate(-30.02)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267,233.93c-.11-.06-.16-.22-.16-.48V223a1.33,1.33,0,0,1,.16-.67,1.3,1.3,0,0,1,.52-.49l4.46-2.58c1.11-.64,1.95-.83,2.51-.56s.84.93.84,2a4.39,4.39,0,0,1-.35,1.67,4.61,4.61,0,0,1-.93,1.47c1-.2,1.56.38,1.56,1.75a5.56,5.56,0,0,1-.4,2,6.6,6.6,0,0,1-1.22,2,8,8,0,0,1-2,1.63l-4.46,2.57C267.3,234,267.12,234,267,233.93Zm4.55-9.56a2.57,2.57,0,0,0,.95-.9,2.27,2.27,0,0,0,.33-1.21c0-.48-.1-.76-.31-.85s-.53,0-1,.25l-2.2,1.28v2.7Zm.25,4.85a2.58,2.58,0,0,0,1.32-2.26c0-.5-.13-.81-.38-.91a1.27,1.27,0,0,0-1.07.23l-2.32,1.35v3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.6,228.86a1.4,1.4,0,0,1,0-.31l3.94-13.11a2.27,2.27,0,0,1,.23-.55,1,1,0,0,1,.38-.33l1.11-.64c.16-.09.28-.13.36-.1a.52.52,0,0,1,.23.28l3.94,8.57a.73.73,0,0,1,0,.25.51.51,0,0,1-.27.46l-1.84,1.06a.49.49,0,0,1-.31.1c-.07,0-.12-.08-.18-.19l-.69-1.67-3.7,2.14-.69,2.46a1.26,1.26,0,0,1-.17.4,1,1,0,0,1-.31.25L275.88,229C275.69,229.1,275.6,229.06,275.6,228.86ZM282,221l-1.27-3.07-1.27,4.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.31,222.21c-.11-.06-.16-.22-.16-.47V211.3a1.27,1.27,0,0,1,.16-.66,1.32,1.32,0,0,1,.54-.5l.94-.54a.88.88,0,0,1,.39-.15.46.46,0,0,1,.28.15l4.26,4.48v-6.55a1.34,1.34,0,0,1,.16-.68,1.37,1.37,0,0,1,.52-.49l1.14-.66c.26-.15.43-.19.54-.12s.15.23.15.5v10.41a1.34,1.34,0,0,1-.15.66,1.37,1.37,0,0,1-.54.49l-1,.56a.76.76,0,0,1-.38.13.46.46,0,0,1-.28-.14l-4.27-4.46v6.56a1.33,1.33,0,0,1-.15.65,1.39,1.39,0,0,1-.54.5l-1.14.65C287.59,222.24,287.41,222.27,287.31,222.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.34,211.11a.51.51,0,0,1-.27.46l-1.9,1.09a1,1,0,0,1-.28.12.26.26,0,0,1-.19-.05l-3.36-3.16,0,0v4.62a1.37,1.37,0,0,1-.15.66,1.45,1.45,0,0,1-.54.49l-1.14.66c-.24.14-.41.18-.52.12s-.16-.23-.16-.48V205.18a1.3,1.3,0,0,1,.16-.67,1.39,1.39,0,0,1,.52-.5l1.14-.66c.26-.14.43-.18.54-.12s.15.23.15.5v4.53l0-.09,3.25-6.89a1,1,0,0,1,.19-.29,1.91,1.91,0,0,1,.31-.23l1.87-1.08c.19-.1.28-.05.28.15a.82.82,0,0,1-.09.33l-3.61,7.44,3.71,3.28A.27.27,0,0,1,306.34,211.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.25,205.5c-1-.51-1.46-1.77-1.46-3.79a10.69,10.69,0,0,1,1.42-5.46,11,11,0,0,1,4.07-3.94,9.35,9.35,0,0,1,2-.91,3.28,3.28,0,0,1,1.53-.15.17.17,0,0,1,.15.19,1,1,0,0,1-.09.35l-.54,1.38a.63.63,0,0,1-.21.31.46.46,0,0,1-.26.05,4.11,4.11,0,0,0-2.29.69,6.45,6.45,0,0,0-2.44,2.45,7.32,7.32,0,0,0-.86,3.6c0,1.38.3,2.25.9,2.59a2.52,2.52,0,0,0,2.47-.39,8.51,8.51,0,0,0,2.41-2,1.22,1.22,0,0,1,.26-.26c.07,0,.14,0,.21.07l.59.84a.32.32,0,0,1,.06.17.83.83,0,0,1-.18.37,11.3,11.3,0,0,1-3.67,3.1C316.58,205.76,315.21,206,314.25,205.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.74,201.64a2.08,2.08,0,0,1,0-.3l4-13.12a1.68,1.68,0,0,1,.23-.55,1.17,1.17,0,0,1,.37-.32l1.11-.65a.5.5,0,0,1,.37-.09.48.48,0,0,1,.23.28l3.94,8.56a.82.82,0,0,1,0,.26.48.48,0,0,1-.27.45l-1.84,1.07a.56.56,0,0,1-.31.1.31.31,0,0,1-.18-.19l-.7-1.67L326,197.6l-.68,2.47a1.45,1.45,0,0,1-.17.39,1,1,0,0,1-.32.26L323,201.78C322.83,201.89,322.74,201.84,322.74,201.64Zm6.4-7.86-1.26-3.06-1.28,4.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.44,195c-.1-.06-.16-.22-.16-.48V184.1a1.44,1.44,0,0,1,.16-.67,1.41,1.41,0,0,1,.53-.49l3.85-2.22q3.85-2.24,3.86,1.66a6.15,6.15,0,0,1-.46,2.38,6.76,6.76,0,0,1-1.35,2.11l1.6,3.12a.51.51,0,0,1,0,.22.55.55,0,0,1-.32.5l-1.68,1a.72.72,0,0,1-.32.13c-.08,0-.14-.06-.19-.17l-1.4-3-1.81,1v3.44a1.18,1.18,0,0,1-.68,1.15l-1.14.66C334.73,195,334.55,195.06,334.44,195Zm4-8.42a3.64,3.64,0,0,0,1.3-1.17,2.86,2.86,0,0,0,.44-1.58c0-.61-.14-1-.4-1.11s-.66,0-1.19.26L336.79,184v3.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.09,189.43c-.11-.06-.16-.22-.16-.48V178.54a1.3,1.3,0,0,1,.16-.67,1.32,1.32,0,0,1,.52-.5l3.2-1.84q2.6-1.51,3.95-.85t1.35,3.75a10,10,0,0,1-1.36,5.31,10.9,10.9,0,0,1-3.94,3.73l-3.2,1.84C344.37,189.45,344.19,189.49,344.09,189.43Zm3.84-4.16a5.12,5.12,0,0,0,2-2,7.15,7.15,0,0,0,.67-3.37c0-1.4-.22-2.26-.67-2.58s-1.12-.21-2,.31l-1.49.86v7.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,285.09v4.47c0,1.41,1,2,2.21,1.28l24.6-14.21A4.9,4.9,0,0,0,295,272.8v-4.47c0-1.41-1-2-2.21-1.28l-24.6,14.21A4.88,4.88,0,0,0,266,285.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.57,265.14v4.47c0,1.41,1,2,2.21,1.27l24.61-14.2a4.9,4.9,0,0,0,2.21-3.83v-4.47c0-1.41-1-2-2.21-1.28l-24.61,14.21A4.88,4.88,0,0,0,300.57,265.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.13,245.18v4.47c0,1.41,1,2,2.21,1.28l24.6-14.21a4.86,4.86,0,0,0,2.21-3.82v-4.48c0-1.41-1-2-2.21-1.27l-24.6,14.2A4.9,4.9,0,0,0,335.13,245.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.68,225.23v4.47c0,1.41,1,2,2.21,1.28l24.61-14.21a4.88,4.88,0,0,0,2.21-3.83v-4.47c0-1.41-1-2-2.21-1.28L371.89,221.4A4.9,4.9,0,0,0,369.68,225.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.94,230.63l-5.64,3.26a2.92,2.92,0,0,0-1.32,2.29v1.73c0,.84.59,1.19,1.32.76l5.64-3.25a2.92,2.92,0,0,0,1.33-2.3v-1.73C386.27,230.55,385.68,230.21,384.94,230.63Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.38,223.45l-5.64,3.25a2.94,2.94,0,0,0-1.32,2.3v1.73c0,.84.59,1.18,1.32.76l5.64-3.26a2.91,2.91,0,0,0,1.33-2.29v-1.73C398.71,223.37,398.12,223,397.38,223.45Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.17,276.53,396.39,236c1.22-.71,2.21-.13,2.21,1.28v2.07a4.88,4.88,0,0,1-2.21,3.83l-70.22,40.54c-1.22.71-2.21.14-2.21-1.27v-2.08A4.9,4.9,0,0,1,326.17,276.53Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fingerprint--inject-282"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.31,110V212.82a4.8,4.8,0,0,0,2.16,3.75l3.8,2.19a4.79,4.79,0,0,0,4.33,0l64.72-37.36a4.8,4.8,0,0,0,2.17-3.75V74.85a4.78,4.78,0,0,0-2.17-3.75l-3.79-2.19a4.79,4.79,0,0,0-4.33,0l-64.73,37.37A4.8,4.8,0,0,0,177.31,110Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.47,74.5c-.15-1.12-1.06-1.53-2.15-.9L187.6,111a4.46,4.46,0,0,0-1.54,1.62l-8.12-4.69a4.6,4.6,0,0,1,1.53-1.62L244.2,68.91a4.79,4.79,0,0,1,4.33,0l3.79,2.19A4.83,4.83,0,0,1,254.47,74.5Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.22,218.93a.35.35,0,0,1-.13,0,1.14,1.14,0,0,1-.26.09h0l-.44.11a5,5,0,0,1-2.61-.21,3.51,3.51,0,0,1-.48-.22l-3.8-2.19a4.8,4.8,0,0,1-2.16-3.75V110a4.43,4.43,0,0,1,.63-2.13l8.12,4.69a4.43,4.43,0,0,0-.63,2.13V217.51a1.8,1.8,0,0,0,.33,1.14,1.13,1.13,0,0,0,1.16.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.72,150.82c2.83,1.89,6.46,2,10.14,1.31",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.45,131c3-.87,4.81.61,5.13,4.85.39,5.22.27,10.13,2.95,13.14",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.52,159c-2.26-5.52-3.42-22.56,3-27",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.89,169.5c-7.37.87-14.32-1.34-18.25-8.24",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.35,165.47c-11.86,1.29-20.31-4.74-18.92-24.94.14-1.9,1.19-4.08,2.6-4.9l.05,0c1.44-.79,2.9.14,2.87,2.06-.21,14.45,4.47,21.16,16.32,19.06",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.13,174.32c-14.83,1-22.77-8.85-21.6-29.62.39-6.86,3-14.46,8.14-17.43a1.59,1.59,0,0,1,.22-.13c5.22-2.87,9.29.14,9.83,7.18.52,6.76.71,14.74,11.88,12.85",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,178.08a21.77,21.77,0,0,0,7,1.27",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.53,169a17.74,17.74,0,0,0,9,8.33",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.42,130.73c-6.4,11.81-4.77,27.65-2.12,35.29",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,133.52c-.6-6.41-2.23-10.79-6.88-11.82-3.71-.81-8.46,1.54-12.23,6.72",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.07,142.73c-3.82,1.34-7.88.51-8.59-5.29",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.34,138.32c-4,.11-5.85-1.67-6.82-8.84-1.49-11-7.18-15.71-16-10.61-9.26,5.34-14.82,18.57-15.24,29.51-.81,20.59,5.65,28.78,15.8,32.93a28.38,28.38,0,0,0,7.06,1.81",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.32,123.28c.79,4.33,1.21,10.37,5.13,10.24",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.66,112.28c3.79.71,6.63,3.86,8.07,8.5",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.91,118.7c4-4.14,8.71-6.39,12.67-6.56",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.4,138.43a45.27,45.27,0,0,1,9.13-17.65",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.92,159a58.56,58.56,0,0,1,.59-17.63",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,175.9a40.75,40.75,0,0,1-4.66-13.4",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.23,187.53c-4.7-1.92-9.94-4.72-13.27-9.2",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,190.53C200.91,184.77,196,169.58,196,152.68s8-35.1,22.49-43.05c9.83-5.38,22.94.45,22.94,17.35",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,161.34a29.71,29.71,0,0,0,5.3-.21",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.32,156a10,10,0,0,0,7.1,5.15",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.33,138.9c-.48,5.8.25,11.13,1.9,14.92",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.69,102.3a15.81,15.81,0,0,1,11.63,2.15",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,113a37.73,37.73,0,0,1,14.4-9.79",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.07,187.84a16.19,16.19,0,0,0,5.35,4.33",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.48,176.7a30.28,30.28,0,0,0,4.79,8.58",
    style: {
      fill: "none",
      stroke: "#455a64",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.25px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Letter--inject-282"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--letter--inject-282"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.44,235.44a4.27,4.27,0,0,1,1.91-3.33l98.15-56.66a4.26,4.26,0,0,1,3.84,0l2.16,1.25a4.24,4.24,0,0,1,1.92,3.32v75.23a4.26,4.26,0,0,1-1.92,3.33L46.35,315.24a4.24,4.24,0,0,1-3.83,0L40.36,314a4.24,4.24,0,0,1-1.92-3.32Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,233.55l5.44,3.14,101.42-58.56a4,4,0,0,0-1.36-1.43l-2.17-1.25a4.24,4.24,0,0,0-3.83,0L40.36,232.11A3.86,3.86,0,0,0,39,233.55Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.43,235.44v75.23A4.25,4.25,0,0,0,40.36,314l2.16,1.25a3.56,3.56,0,0,0,.52.24,4.44,4.44,0,0,0,2.31.12,2.24,2.24,0,0,0,.37-.1.92.92,0,0,0,.23-.09,1.16,1.16,0,0,1-.92,0,1.35,1.35,0,0,1-.59-1.27V238.9a1.67,1.67,0,0,1,1-1.63l-1-.58L39,233.55A3.9,3.9,0,0,0,38.43,235.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.44,236.69l45.45,17a7.38,7.38,0,0,0,8.77-2.89L106,239.6l40.26-61.68L107.42,240l39,15.27a4.06,4.06,0,0,1-.6,1.91l-38.51-17-8.49,13.57a7.38,7.38,0,0,1-9.24,2.84l-6-2.67L45,315.4a1.35,1.35,0,0,1-.59-1.27v-1.25l38.91-59Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-282"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.22,28a1.54,1.54,0,0,0-.59-1.37h0l-.05,0-4-2.33h0a1.5,1.5,0,0,0-1.52.15L323,60.12l-1.67-5.57a2,2,0,0,0-.9-1.2h0L316.39,51v0a1.91,1.91,0,0,0-2,.05L287.77,66.43a4.8,4.8,0,0,0-2.16,3.75V159a1.57,1.57,0,0,0,.59,1.37h0l.05,0h0l4,2.33.05,0,0,0h0a1.57,1.57,0,0,0,1.48-.18l97.22-56.13a4.8,4.8,0,0,0,2.16-3.75Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.4,53.32a1.94,1.94,0,0,0-1.94.09L291.83,68.78a4.6,4.6,0,0,0-1.53,1.62l-4.06-2.35a4.35,4.35,0,0,1,1.53-1.62L314.4,51.06a1.93,1.93,0,0,1,2-.05h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.47,26.51a1.62,1.62,0,0,0-1.42.21L326.39,62.87a1.89,1.89,0,0,1-2.89-1.15l-.48-1.6,62-35.75a1.92,1.92,0,0,1,1-.29,1.13,1.13,0,0,1,.56.14h0Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,162.43a1.15,1.15,0,0,0,.21.23l-3.93-2.26h0l0,0a1.17,1.17,0,0,1-.37-.42,1.09,1.09,0,0,1-.1-.25,2.1,2.1,0,0,1-.11-.7V70.18a2.26,2.26,0,0,1,0-.26,5.07,5.07,0,0,1,.09-.54c0-.09.05-.18.07-.27a6.13,6.13,0,0,1,.33-.8,2.15,2.15,0,0,1,.14-.26l4.06,2.35a4.4,4.4,0,0,0-.63,2.13v88.81a2.34,2.34,0,0,0,0,.38,1.55,1.55,0,0,0,0,.21l0,.11.06.14A.89.89,0,0,0,290,162.43Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Password--inject-282"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.68,307.74A5.93,5.93,0,0,0,222,303.1l-2.18-1.26a6,6,0,0,0-5.36,0l-72.41,41.78a5.93,5.93,0,0,0-2.68,4.64v8.53a5.93,5.93,0,0,0,2.68,4.64l2.19,1.26a5.93,5.93,0,0,0,5.35,0L222,320.91a5.91,5.91,0,0,0,2.68-4.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.37,356.79a5.91,5.91,0,0,0,2.68,4.64l2.19,1.26a6,6,0,0,0,4.9.21c-1.27.48-2.23-.23-2.23-1.76v-8.52a5.45,5.45,0,0,1,.79-2.65l-7.54-4.35a5.44,5.44,0,0,0-.79,2.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.59,307c-.31-1.14-1.35-1.5-2.59-.79L149.59,348a5.3,5.3,0,0,0-1.89,2l-7.53-4.35a5.35,5.35,0,0,1,1.88-2l72.4-41.79a6,6,0,0,1,5.36,0l2.19,1.27A5.9,5.9,0,0,1,224.59,307Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.13,349c1.41-.81,2.55-.15,2.55,1.47a5.62,5.62,0,0,1-2.55,4.41c-1.4.81-2.54.15-2.54-1.47A5.64,5.64,0,0,1,156.13,349Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.55,344.17c1.4-.81,2.54-.15,2.54,1.47a5.63,5.63,0,0,1-2.54,4.41c-1.41.81-2.54.15-2.54-1.47A5.63,5.63,0,0,1,164.55,344.17Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,339.32c1.41-.81,2.55-.16,2.55,1.47a5.61,5.61,0,0,1-2.55,4.4c-1.4.81-2.54.15-2.54-1.47A5.62,5.62,0,0,1,173,339.32Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.38,334.46c1.4-.81,2.54-.15,2.54,1.47a5.62,5.62,0,0,1-2.54,4.4c-1.41.81-2.55.16-2.55-1.47A5.61,5.61,0,0,1,181.38,334.46Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.79,329.6c1.41-.81,2.55-.15,2.55,1.47a5.64,5.64,0,0,1-2.55,4.41c-1.4.81-2.54.15-2.54-1.47A5.63,5.63,0,0,1,189.79,329.6Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.21,324.74c1.4-.81,2.54-.15,2.54,1.47a5.64,5.64,0,0,1-2.54,4.41c-1.41.81-2.55.15-2.55-1.47A5.62,5.62,0,0,1,198.21,324.74Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.62,319.88c1.4-.81,2.54-.15,2.54,1.47a5.63,5.63,0,0,1-2.54,4.41c-1.4.81-2.54.15-2.54-1.47A5.66,5.66,0,0,1,206.62,319.88Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,315c1.41-.81,2.55-.16,2.55,1.47a5.61,5.61,0,0,1-2.55,4.4c-1.4.81-2.54.15-2.54-1.47A5.62,5.62,0,0,1,215,315Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.68,335.87a5.93,5.93,0,0,0-2.68-4.64L219.82,330a6,6,0,0,0-5.36,0l-72.41,41.78a5.91,5.91,0,0,0-2.68,4.64v8.53a5.93,5.93,0,0,0,2.68,4.64l2.19,1.26a5.93,5.93,0,0,0,5.35,0L222,349a5.91,5.91,0,0,0,2.68-4.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.37,384.92a5.93,5.93,0,0,0,2.68,4.64l2.19,1.26a6,6,0,0,0,4.9.21c-1.27.48-2.23-.23-2.23-1.76v-8.53a5.44,5.44,0,0,1,.79-2.64l-7.54-4.35a5.44,5.44,0,0,0-.79,2.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.59,335.11c-.31-1.14-1.35-1.5-2.59-.79l-72.41,41.79a5.3,5.3,0,0,0-1.89,2l-7.53-4.35a5.35,5.35,0,0,1,1.88-2L214.45,330a6,6,0,0,1,5.36,0l2.19,1.27A5.9,5.9,0,0,1,224.59,335.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.13,377.16c1.41-.81,2.55-.15,2.55,1.47a5.64,5.64,0,0,1-2.55,4.41c-1.4.81-2.54.15-2.54-1.47A5.63,5.63,0,0,1,156.13,377.16Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.55,372.3c1.4-.81,2.54-.15,2.54,1.47a5.64,5.64,0,0,1-2.54,4.41c-1.41.81-2.54.15-2.54-1.47A5.61,5.61,0,0,1,164.55,372.3Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,367.45c1.41-.82,2.55-.16,2.55,1.46a5.61,5.61,0,0,1-2.55,4.41c-1.4.81-2.54.15-2.54-1.47A5.62,5.62,0,0,1,173,367.45Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.38,362.59c1.4-.81,2.54-.16,2.54,1.47a5.62,5.62,0,0,1-2.54,4.4c-1.41.81-2.55.16-2.55-1.47A5.61,5.61,0,0,1,181.38,362.59Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.79,357.73c1.41-.81,2.55-.15,2.55,1.47a5.61,5.61,0,0,1-2.55,4.4c-1.4.81-2.54.16-2.54-1.46A5.63,5.63,0,0,1,189.79,357.73Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.21,352.87c1.4-.81,2.54-.15,2.54,1.47a5.66,5.66,0,0,1-2.54,4.41c-1.41.81-2.55.15-2.55-1.47A5.61,5.61,0,0,1,198.21,352.87Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.62,348c1.4-.81,2.54-.15,2.54,1.47a5.64,5.64,0,0,1-2.54,4.41c-1.4.81-2.54.15-2.54-1.47A5.64,5.64,0,0,1,206.62,348Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,343.16c1.41-.82,2.55-.16,2.55,1.46A5.61,5.61,0,0,1,215,349c-1.4.81-2.54.15-2.54-1.47A5.62,5.62,0,0,1,215,343.16Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,358.32a5.94,5.94,0,0,0-2.68-4.64l-2.19-1.26a5.93,5.93,0,0,0-5.35,0L93.31,371.78a5.91,5.91,0,0,0-2.68,4.64v36.69a5.94,5.94,0,0,0,2.68,4.64L95.49,419a6,6,0,0,0,5.36,0l33.46-19.36A5.91,5.91,0,0,0,137,395Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.63,413.11a5.94,5.94,0,0,0,2.68,4.64L95.49,419a6,6,0,0,0,4.9.21c-1.26.48-2.22-.23-2.22-1.76V380.77a5.53,5.53,0,0,1,.78-2.64l-7.54-4.35a5.5,5.5,0,0,0-.78,2.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.9,357.56c-.32-1.13-1.35-1.5-2.59-.78l-33.46,19.35a5.29,5.29,0,0,0-1.89,2l-7.54-4.35a5.45,5.45,0,0,1,1.89-2l33.45-19.35a6,6,0,0,1,5.36,0l2.19,1.26A5.9,5.9,0,0,1,136.9,357.56Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.08,372.67c3.22-1.86,5.83-.36,5.83,3.36a12.89,12.89,0,0,1-5.83,10.1c-3.22,1.86-5.83.35-5.83-3.37A12.85,12.85,0,0,1,117.08,372.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.57,392.49c0-6.11-4.29-8.58-9.58-5.53l-3.31,1.91c-5.28,3.05-9.57,10.48-9.57,16.59v1.64c3,1,19.36-8.48,22.46-13.19Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shield--inject-282"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.2,286.26h0l-12.19-7h0c-.48-.26-1.19-.08-2,.57-.45.34-.9.67-1.36,1l-.5.32-.9.57-.65.36c-.26.15-.53.31-.8.45s-.49.24-.74.36-.48.25-.73.36l-.82.35-.68.28q-.45.18-.9.33l-.62.23-1,.29-.57.17c-.34.1-.69.18-1,.26l-.51.12-1.1.22-.45.08-1.17.17-.38,0c-.41,0-.82.09-1.23.11l-.32,0c-.43,0-.85,0-1.28.05H406c-.44,0-.88,0-1.32,0h-.2c-.46,0-.91-.06-1.37-.1l-.13,0-1.41-.18h-.07l-1.18-.23a3.63,3.63,0,0,0-.85-.69h0l-.14-.08h0l-12-6.94h0c-1-.57-1.92-.16-2.5,1.3-7.87,19.52-24.62,39.32-35.78,44.27a4.31,4.31,0,0,0-.64.33c-.14.08-.26.17-.4.26s-.11.08-.17.13a4.63,4.63,0,0,0-.48.4l0,0c-.16.16-.32.32-.47.5h0a4.68,4.68,0,0,0-1.24,3.18l1.61,43.86c0,12.78,5.44,26.28,16.54,32.73h0l12.18,7h0l.16.09h0a30.6,30.6,0,0,0,18.51,3.62,12,12,0,0,0,6.36-3.17C425.36,387,437.23,352.85,437.23,334l1.61-45.86C438.87,287.12,438.63,286.51,438.2,286.26Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.63,411.49l-11.89-6.87h0c-11.09-6.45-16.54-19.95-16.54-32.73L345.58,328a5,5,0,0,1,2-3.92,6.46,6.46,0,0,0-.74.74l12.18,7a4.66,4.66,0,0,0-1.24,3.2l1.6,43.85C359.37,391.6,364.73,405,375.63,411.49Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.18,286.24c-.47-.25-1.17-.06-2,.59-11,8.38-27.35,8.39-35.69-1.32l-.15-.17A29.66,29.66,0,0,0,424,279.79c.86-.66,1.56-.83,2-.57h0Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.33,284.57h0c-.93-.44-1.78,0-2.33,1.38-7.86,19.53-24.62,39.32-35.79,44.27a6.37,6.37,0,0,0-2.19,1.64l-12.18-7a6.46,6.46,0,0,1,.74-.74l.27-.22a2.83,2.83,0,0,0,.28-.2l.3-.18a4.25,4.25,0,0,1,.6-.31c11.16-4.95,27.92-24.75,35.78-44.28.42-1,1-1.53,1.67-1.53a1.6,1.6,0,0,1,.83.24Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.11 328.36 452.61 324.6 427.12 384.67 431.47 387.18 459.11 328.36",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.5 368.69 413.99 364.94 407 379.73 413.51 383.48 420.5 368.69",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.14 404.79 413.51 383.48 420.5 368.69 431.47 387.18 459.11 328.36 469.36 338.36 433.14 404.79",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407 379.73 413.51 383.48 433.14 404.79 426.64 401.08 407 379.73",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.f0e50ecf3606b4a03fcb13b5bb61b55e.svg";
export { ForwardRef as ReactComponent };